module.exports = __webpack_public_path__ + "img/ic-acessibilidade-aumentar-texto.62c36fc4.svg";